/* src/app/reconciliation/reconciliation-memorize-template-popup/reconciliation-memorize-template-popup.component.scss */
body#themeTag :host ::ng-deep p-footer .p-toolbar > * {
  flex-basis: 65px;
}
form input {
  width: 100%;
}
/*# sourceMappingURL=reconciliation-memorize-template-popup.component.css.map */
